import { Table, Tag } from 'antd';
import moment from 'moment';
import { TransactionEntity } from '../../../../../entities/transaction.entity';
import { YELLOW } from '../../../../../shared/colors';
import { formatNum } from '../../../../../shared/constants';

export const TransactionEnCours = ({
  transactions,
}: {
  transactions: TransactionEntity[];
}) => {
  const COLUMNS = [
    {
      title: 'Asset manager',
      render: (cell: any, row: any) =>
        `${row.assetManager.code_referent} - ${row.assetManager.nom}`,
    },
    {
      title: 'Partenaire',
      render: (cell: any, row: any) =>
        `${row.partenaire.code_referent} - ${row.partenaire.nom}`,
    },
    {
      title: 'Agence',
      render: (cell: any, row: any) => `${row.agence.code} - ${row.agence.nom}`,
    },
    {
      title: 'Emetteur',
      render: (cell: any, row: TransactionEntity) => row.bond.pays,
    },
    {
      title: 'Code Titre',
      render: (cell: any, row: TransactionEntity) => row.bond.code,
    },
    {
      title: 'Code transaction',
      dataIndex: 'code',
    },
    {
      title: 'Detenteur',
      render: (cell: any, row: TransactionEntity) =>
        `${row.detenteur?.code_referent} - ${row.detenteur?.nom} ${row.detenteur?.prenom}`,
    },
    {
      title: 'Gestionnaire',
      render: (cell: any, row: any) =>
        `${row.utilisateur?.nom} ${row.utilisateur?.prenom}`,
    },
    {
      title: 'Opération',
      dataIndex: 'typeOperation',
    },
    {
      title: 'Date Opération',
      dataIndex: 'dateOperation',
      render: (cell: any) => `${moment(cell).format('DD/MM/YYYY')}`,
    },
    {
      title: 'Statut',
      dataIndex: 'statut',
      render: (cell: any) =>
        cell === 'finalisé' ? (
          <Tag color='#008000'>Finalisé</Tag>
        ) : (
          <Tag color={YELLOW}>En cours</Tag>
        ),
    },
    {
      title: 'Qte',
      dataIndex: 'qte',
      render: (cell: any, row: TransactionEntity) => `${formatNum(cell)}`,
    },
    {
      title: 'Coupon',
      dataIndex: 'tauxInteret',
    },
    {
      title: 'Décote',
      dataIndex: 'decote',
    },
    {
      title: 'Rendement',
      dataIndex: 'tauxRendement',
    },
    {
      title: 'Prix',
      render: (cell: any, row: TransactionEntity) =>
        `${formatNum(row.prixNominale * 1)}`,
    },
    {
      title: 'Montant restant',
      render: (cell: any, row: TransactionEntity) =>
        `${formatNum(row.qte * row.prixNominale)}`,
    },
    {
      title: 'Commission',
      render: (cell: any, row: TransactionEntity) =>
        `${formatNum(
          Math.ceil(
            Number(row.commIntermediation) +
              Number(row.commConservation) +
              Number(row.commDroitGarde) +
              Number(row.commBrokerage),
          ),
        )}`,
    },
    {
      title: 'Net à payer',
      render: (cell: any, row: TransactionEntity) =>
        `${formatNum(
          Math.ceil(
            Number(row.qte) * Number(row.prixNominale) +
              Number(row.couponCouruPayer) +
              Number(row.commIntermediation) +
              Number(row.commConservation) +
              Number(row.commDroitGarde) +
              Number(row.commBrokerage),
          ),
        )}`,
    },
  ];

  return (
    <div>
      <Table
        columns={COLUMNS}
        dataSource={transactions}
        rowKey='id'
        rowClassName={(row, index) =>
          index % 2 === 0 ? 'even-row' : 'odd-row'
        }
        size='small'
        style={{ zoom: 0.9 }}
        pagination={{
          defaultPageSize: 20,
          position: ['bottomRight'],
        }}
        scroll={{ x: 'max-content' }}
      />
    </div>
  );
};
